module.exports = __webpack_public_path__ + "static/media/new-portfolio-2.abfb0e7b.JPG";